import type { ChatScenario } from "../../types/chat";
import { validateScenario } from "../validateScenario";
import chatPreliminary from "./chatPreliminary.json";

const toScenario = (json: { id: string; version: number; steps: string[] }) => {
  const errors = validateScenario(json);
  if (errors.length > 0) {
    throw new Error(`Invalid chat scenario "${json.id}": ${errors.join("; ")}`);
  }
  return json as ChatScenario;
};

// Every user's onboarding; variations are new scenarios over the same steps.
export const chatScenario = toScenario(chatPreliminary);
